export const SUBSCRIPTION_RENEW_MONTH = 9; // October
export const SUBSCRIPTION_RENEW_DAY = 1; // 1st
